import HeroCarousel from '../components/HeroCarousel';
import SearchBar from '../components/SearchBar';
import HotDealsSection from '../components/HotDealsSection';
import CategoryGrid from '../components/CategoryGrid';
import AboutUs from '../components/AboutUs';

export default function Home() {
  return (
    <div className="min-h-screen bg-background">
      {/* Hero Carousel */}
      <HeroCarousel />

      {/* Search Bar - positioned over carousel bottom area */}
      <div className="relative -mt-8 md:-mt-12 z-10 container px-4 max-w-3xl mx-auto">
        <div className="bg-background rounded-lg shadow-lg p-4 border border-border">
          <SearchBar />
        </div>
      </div>

      {/* Hot Deals Section */}
      <HotDealsSection />

      {/* Shop by Category */}
      <CategoryGrid />

      {/* About Us */}
      <AboutUs />

      {/* Mobile spacer for bottom nav */}
      <div className="h-16 md:hidden" />
    </div>
  );
}